import { render, staticRenderFns } from "./crear_modal.vue?vue&type=template&id=d36a2658"
import script from "./crear_modal.vue?vue&type=script&lang=js"
export * from "./crear_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports